const faqItemComponent = {
    $faqItems:        undefined,
    $faqEntries:      undefined,
    $faqEntryButtons: undefined,
    $faqInfo:         undefined,
    $htmlBody:        undefined,

    closeFaqItems(faqItem, faqEntry) {
        this.$faqItems.map((itemIndex, item) => {
            if (itemIndex !== faqItem) {
                $(item).parent().removeClass('faq-item--active')
            }
        });

        this.$faqEntries.map((index, entry) => {
            if (entry !== faqEntry) {
                $(entry).removeClass('faq-entry--active')
            }
        });

        this.$faqInfo.removeClass('faq-info--inactive');
    },

    faqItemClickHandler(faqItem) {
        const componentId = faqItem.attr('id').substr(8, faqItem.attr('id').length),
              $faqEntry   = $('#faqEntry-' + componentId);
        this.closeFaqItems(faqItem.parent().index(), $faqEntry);
        this.$faqInfo.addClass('faq-info--inactive');
        faqItem.parent().addClass('faq-item--active');
        $faqEntry.addClass('faq-entry--active');

        // Firefox places the overflow at the html level,
        // unless specifically styled to behave differently.
        // so body, html need to be used in selector for accurate scroll
        faqItemComponent.$htmlBody.animate({
            scrollTop: $faqEntry.offset().top - 120
        });
    },
    init() {
        faqItemComponent.$faqItems = $('.faq-item');
        if (faqItemComponent.$faqItems.length) {
            faqItemComponent.$faqItems.first().addClass('faq-item--first');
            faqItemComponent.$faqEntries      = $('.faq-entry');
            faqItemComponent.$faqEntryButtons = $('.faq-entry__button');
            faqItemComponent.$faqInfo         = $('.faq-info').first();
            faqItemComponent.$htmlBody        = $('body, html');

            faqItemComponent.$faqItems.on('click', function () {
                faqItemComponent.faqItemClickHandler($(this));
            });

            faqItemComponent.$faqEntryButtons.on('click', function () {
                faqItemComponent.closeFaqItems();
            });
        }
    }
};

const accordionPage = {
    $headerSlot:         undefined,
    $accordionContainer: undefined,
    openCollapse() {
        accordionPage.$headerSlot.hide();
        accordionPage.$accordionContainer.addClass('accordion-container--collapse');
    },
    closeCollapse() {
        accordionPage.$headerSlot.show();
        accordionPage.$accordionContainer.removeClass('accordion-container--collapse');
    },
    init() {
        accordionPage.$headerSlot         = $('.accordion-page .header-slot');
        accordionPage.$accordionContainer = $('.accordion-page .accordion-container');
    }
}

$(() => {
    faqItemComponent.init();
    accordionPage.init();
});
export default accordionPage;
